export const FEATURE_CHAT_MESSAGES_MONTHLY = 'feature.chat.messages.monthly';
export const FEATURE_DATASETS_INDEXED_TOTAL = 'feature.datasets.indexed.total';
export const FEATURE_STORAGE_BYTES_TOTAL = 'feature.storage.bytes.total';
export const FEATURE_INTEGRATION_BIGQUERY = 'feature.integration.bigquery';
export const FEATURE_INTEGRATION_UDF = 'feature.integration.udf';
export const FEATURE_TRIAL_ENABLED = 'feature.trial.enabled';
export const LIMIT_TRIAL_DAYS = 'limit.trial.days';
